import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";

export const UnsavedChangesDialog = ({ description, onDiscard, onKeepEditing, onSaveAndClose, open, saveDisabled = false, testIdPrefix, title }) => (
  <Dialog onOpenChange={(nextOpen) => {
    if (!nextOpen) {
      onKeepEditing();
    }
  }} open={open}>
    <DialogContent className="border-zinc-300 sm:max-w-md" data-testid={`${testIdPrefix}-dialog`}>
      <DialogHeader>
        <DialogTitle data-testid={`${testIdPrefix}-title`}>{title}</DialogTitle>
        <DialogDescription data-testid={`${testIdPrefix}-description`}>{description}</DialogDescription>
      </DialogHeader>
      <DialogFooter className="gap-2 sm:justify-between sm:space-x-0">
        <button className="rounded-lg border border-zinc-300 bg-white px-4 py-2 text-sm font-semibold text-zinc-700 transition hover:border-zinc-900 hover:text-zinc-900" data-testid={`${testIdPrefix}-keep-editing`} onClick={onKeepEditing} type="button">Keep editing</button>
        <div className="flex flex-col-reverse gap-2 sm:flex-row">
          <button className="rounded-lg border border-red-300 bg-white px-4 py-2 text-sm font-semibold text-red-600 transition hover:bg-red-50" data-testid={`${testIdPrefix}-discard`} onClick={onDiscard} type="button">Discard changes</button>
          <button className="rounded-lg bg-zinc-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-zinc-800 disabled:cursor-not-allowed disabled:opacity-60" data-testid={`${testIdPrefix}-save-and-close`} disabled={saveDisabled} onClick={onSaveAndClose} type="button">Save and close</button>
        </div>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);